module.exports = __webpack_public_path__ + "43f29fb9fa3965d6ca028e51731f6d4d.png";